import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1b07edf3&scoped=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"
import style0 from "./detail.vue?vue&type=style&index=0&id=1b07edf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b07edf3",
  null
  
)

export default component.exports